import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default function PuntoLimpioMapaUbicacion({ info }) {
  if (!info?.lat || !info?.lng) return null;
  const position = [info.lat, info.lng];
  return (
    <div className="h-56 rounded-xl overflow-hidden border border-white/20 mt-4" data-testid="puntolimpio-ubicacion-mapa">
      <MapContainer center={position} zoom={16} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={position}>
          <Popup>
            {info.ubicacion} — {info.fecha} ({info.horario})
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}
